import { useState, useEffect } from "react";
import Axios from "middleware/axiosInstance";
import "antd/dist/antd.css";
import { Row, Col, Form, Input, Select } from "antd";
import ButtonComponent from "components/Form/ButtonComponent";
import OpenNotificationWithIcon from "layouts/notificationWithIcon/OpenNotificationWithIcon ";
import { useNavigate, useParams } from "react-router-dom";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import Icon from "react-multi-date-picker/components/icon";
import Loading from "layouts/Loading/Loading";
import { convertToMiladi, convertToShamsi } from "utils/dateCoverter";

const { Option } = Select;
const { TextArea } = Input;
const EditPerson = () => {
  // start react router url params
  const UrlParams = useParams();
  const personId = UrlParams.id;
  // end react router url params
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [person, setPerson] = useState(null);
  const [editedPersonInfo, setEditedPersonInfo] = useState(null);
  const [peopleGroup, setPeopleGroup] = useState(null);
  const [allProvinceAndCities, setAllProvinceAndCities] = useState(null);
  const [citiesOfSelectedProvince, setCitiesOfSelectedProvince] =
    useState(null);
  const [birthdate, setBirthdate] = useState(null);

  const getPersonWithId = () => {
    Axios.get(`/people/${personId}`)
      .then((res) => {
        setPerson(res.data);
        // convert date in two format and add to
        if (res.data.birth_day) {
          const dateInShamsi = convertToShamsi(res.data.birth_day);
          const dateInMiladi = res.data.birth_day;
          setBirthdate({ shamsi: dateInShamsi, miladi: dateInMiladi });
        }
      })
      .catch((err) => {
        OpenNotificationWithIcon(
          "دریافت ناموفق",
          "دریافت اطلاعات شخص ناموفق بود",
          "error"
        );
      });
  };

  const editPersonHandler = (newPersonInfo) => {
    Axios.put(`/people/${personId}`, newPersonInfo)
      .then((res) => {
        console.log(res);
        OpenNotificationWithIcon("ثبت موفق", "ویرایش با موفقیت انجام شد");
        navigate("/warehouse/persons");
      })
      .catch((res) => {
        console.log(res);
      });
  };

  const getPeopleGroup = () => {
    Axios.get("/g_people")
      .then((res) => {
        setPeopleGroup(res.data);
      })
      .catch((err) => {
        setPeopleGroup(false);
        alert("گروه اشخاص دریافت نشد");
        console.log(err);
      });
  };

  const getAndSetAllprovince = () => {
    Axios.get("/province")
      .then((res) => {
        setAllProvinceAndCities(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getAndSetAllCitiesOfSelectedProvince = () => {
    Axios.get(`/province?id=${editedPersonInfo.province_id}`)
      .then((res) => {
        setCitiesOfSelectedProvince(res.data[0].city);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getPersonWithId();
    getPeopleGroup();
    getAndSetAllprovince();
  }, []);

  useEffect(() => {
    editedPersonInfo?.province_id && getAndSetAllCitiesOfSelectedProvince();
  }, [editedPersonInfo?.province_id]);

  const changeBirthdateHandler = (e) => {
    const dateInShamsi = `${e.year}-${e.month.number}-${e.day}`;
    const dateInMiladi = convertToMiladi(dateInShamsi);
    setBirthdate({ shamsi: dateInShamsi, miladi: dateInMiladi });
    setEditedPersonInfo({
      ...editedPersonInfo,
      dob: dateInMiladi,
    });
  };

  const handleFormValuesChange = (changedValues) => {
    setEditedPersonInfo(changedValues);
  };
  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        {person ? (
          <Form
            form={form}
            layout="vertical"
            autoComplete="off"
            onValuesChange={handleFormValuesChange}
            initialValues={person}
            onFinish={editPersonHandler}
          >
            <Row gutter={8}>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item name="people_id" label=" گروه">
                  <Select
                    filterOption={(input, option) =>
                      option.children.includes(input)
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                    }
                    showSearch
                    placeholder="انتخاب فرمایید"
                  >
                    {peopleGroup?.map((peopleGroup) => {
                      return (
                        <Option key={peopleGroup.id} value={peopleGroup.id}>
                          {peopleGroup.name}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  label="نام"
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: " لطفا نام را وارد فرمایید  ",
                    },
                    { min: 2 },
                    { max: 40 },
                  ]}
                  hasFeedback
                >
                  <Input placeholder="نام " />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  label=" نام خانوادگی"
                  name="family"
                  rules={[
                    {
                      required: true,
                      message: " لطفا  نام خانوادگی را وارد فرمایید  ",
                    },
                    { min: 2 },
                    { max: 50 },
                  ]}
                  hasFeedback
                >
                  <Input placeholder=" نام خانوادگی " />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item name="dob" label="تاریخ تولد">
                  <Input
                    disabled
                    placeholder={
                      birthdate ? `${birthdate.shamsi}` : "انتخاب تاریخ"
                    }
                    addonBefore={
                      <DatePicker
                        // value={newWarehouseEntryDocument.date}
                        onChange={(e) => changeBirthdateHandler(e)}
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-left"
                        // format="HH:MM"
                        // plugins={[<TimePicker hideSeconds />]}
                        render={
                          <Icon
                            style={{
                              color: "gray",
                              width: "23px",
                            }}
                          />
                        }
                      />
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item name="phone" label="تلفن ثابت">
                  <Input
                    rules={[{ min: 11 }, { max: 11 }]}
                    placeholder="02136589471"
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="cellular_phone"
                  label="تلفن همراه"
                  rules={[{ min: 11 }, { max: 11 }]}
                  hasFeedback
                >
                  <Input placeholder="09122222222" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item name="type_person" label="نوع شخص">
                  <Select placeholder="حقیقی">
                    <Select.Option value="genuine">حقیقی</Select.Option>
                    <Select.Option value="legal">حقوقی</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                {editedPersonInfo?.type_person === "genuine" ? (
                  <Form.Item
                    name="national_code"
                    label="کدملی"
                    rules={[{ min: 10 }, { max: 10 }]}
                    hasFeedback
                  >
                    <Input placeholder="037111111" />
                  </Form.Item>
                ) : (
                  <Form.Item
                    name="shenaseh_melli"
                    label="شناسه ملی"
                    rules={[{ min: 11 }, { max: 11 }]}
                    hasFeedback
                  >
                    <Input placeholder="037111111" />
                  </Form.Item>
                )}
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="moravedat"
                  label="مراودات"
                  rules={[
                    {
                      required: true,
                      message: "لطفا نوع مراودات را انتخاب فرمایید",
                    },
                  ]}
                >
                  <Select placeholder="انتخاب فرمایید">
                    <Select.Option value="moshtari">مشتری</Select.Option>
                    <Select.Option value="tamin_konande">
                      تامین کننده
                    </Select.Option>
                    <Select.Option value="karkonan">کارکنان</Select.Option>
                    <Select.Option value="vaseteh">واسطه</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item label=" نام شرکت" name="company_name" hasFeedback>
                  <Input placeholder=" نام شرکت" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="code"
                  label="کد"
                  rules={[{ min: 5 }]}
                  hasFeedback
                >
                  <Input placeholder="111" type="number" onWheel={(e) => e.target.blur()}/>
                </Form.Item>
              </Col>
              {editedPersonInfo?.type_person === "legal" ? (
                <Col xs={24} sm={12} md={8} lg={6}>
                  <Form.Item
                    name="economic_code"
                    label="کد اقتصادی"
                    rules={[{ min: 5 }]}
                    hasFeedback
                  >
                    <Input placeholder="852555" />
                  </Form.Item>
                </Col>
              ) : null}
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item name="province_id" label=" استان">
                  <Select
                    filterOption={(input, option) =>
                      option.children.includes(input)
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                    }
                    showSearch
                    placeholder="انتخاب فرمایید"
                  >
                    {allProvinceAndCities?.map((allProvinceAndCities) => {
                      return (
                        <Option
                          key={allProvinceAndCities.id}
                          value={allProvinceAndCities.id}
                        >
                          {allProvinceAndCities.name}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item name="city_id" label="شهر ">
                  <Select
                    filterOption={(input, option) =>
                      option.children.includes(input)
                    }
                    filterSort={(optionA, optionB) =>
                      optionA.children
                        .toLowerCase()
                        .localeCompare(optionB.children.toLowerCase())
                    }
                    showSearch
                    placeholder="ابتدا استان را انتخاب فرمایید"
                  >
                    {citiesOfSelectedProvince?.map(
                      (citiesOfSelectedProvince) => {
                        return (
                          <Option
                            key={citiesOfSelectedProvince.id}
                            value={citiesOfSelectedProvince.id}
                          >
                            {citiesOfSelectedProvince.name}
                          </Option>
                        );
                      }
                    )}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="postal_code"
                  label="کد پستی"
                  rules={[{ min: 10 }, { max: 10 }]}
                  hasFeedback
                >
                  <Input placeholder="852555" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Form.Item
                  name="email"
                  label="ایمیل"
                  rules={[
                    { type: "email", message: "ایمیل صحیح را وارد فرمایید" },
                  ]}
                  hasFeedback
                >
                  <Input placeholder="aa@gmail.com" />
                </Form.Item>
              </Col>
            </Row>
            <Col xs={12} sm={16} md={24} lg={24}>
              <Form.Item name="address" label="آدرس">
                <TextArea rows={3} />
              </Form.Item>
            </Col>
            <Row>
              {/* <Button
              style={{ width: "50%", margin: "auto" }}
              type="primary"
              htmlType="submit"
              onClick={() => CreatePersonHandler()}
            >
              ثبت
            </Button> */}
              <ButtonComponent
                // onClick={() => CreatePersonHandler()}
                type="submit"
                value="ثبت تغییرات"
              />
            </Row>
          </Form>
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
};

export default EditPerson;
